// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { InviteUserComponent } from './invite-user/invite-user.component';
import { LoginRoutingModule } from './login-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../shared/material.module';
import { LoginFormComponent } from './login-form/login-form.component';
import { LoginComponent } from './login.component';
import { NewPasswordComponent } from './new-password/new-password.component';
import { ResetPasswordFormComponent } from './reset-password-form/reset-password-form.component';
import { ResetTokenFormComponent } from './reset-token-form/reset-token-form.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GetStartedComponent } from './get-started/get-started.component';
import { BuyerDashboardModule } from '../buyer-dashboard/buyer-dashboard.module';
import { SharedModule } from '../shared/shared.module';
import { TokenVerifyComponent } from './token-verify/token-verify.component';
import { SelfEnrollmentModule } from './self-enrollment/self-enrollment.module';
import { RequestAccessFormComponent } from './request-access-form/request-access-form.component';

@NgModule({
    declarations: [
        GetStartedComponent,
        InviteUserComponent,
        LoginComponent,
        LoginFormComponent,
        NewPasswordComponent,
        RequestAccessFormComponent,
        ResetPasswordFormComponent,
        ResetTokenFormComponent,
        TokenVerifyComponent,
    ],
    imports: [
        BrowserAnimationsModule,
        BrowserModule,
        CommonModule,
        LoginRoutingModule,
        FormsModule,
        MaterialModule,
        ReactiveFormsModule,
        RouterModule,
        BuyerDashboardModule,
        SelfEnrollmentModule,
        SharedModule,
    ],
    exports: [NewPasswordComponent],
})
export class LoginModule {}
